// assets/edm-bundle-ui-interactions.js
// Event Listeners (Klicks, Swipes, Keyboard) - Ruft Funktionen im Controller auf

window.EdumonBundle = window.EdumonBundle || {};

window.EdumonBundle.UIInteractions = {
  /**
   * Attach PDP-specific listeners
   * @param {Object} controller - Controller instance
   * @param {Element} el - Bundle builder element
   * @param {Object} state - State instance
   * @param {Array} slots - Slot elements
   * @param {Array} cards - Card elements
   * @param {number} maxSlots - Maximum slots
   * @param {Function} flyToSlot - Animation function
   * @param {Function} updateUI - UI update function
   * @param {Function} markDirty - Mark dirty function
   */
  attachPDPListeners: function(controller, el, state, slots, cards, maxSlots, flyToSlot, updateUI, markDirty) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const SELECTORS = Config.SELECTORS;
    
    // Karten-Klick (Desktop add)
    el.querySelectorAll(SELECTORS.CARD_MEDIA).forEach(cardMedia => {
      const card = cardMedia.closest('.bb__card');
      const vid = card?.dataset.variantId;
      const img = cardMedia.querySelector('img');
      cardMedia.addEventListener('click', async () => {
        if (!vid) return;
        if (Object.values(state.items).reduce((a, b) => a + b, 0) >= maxSlots) return;
        const targetSlot = slots.find(s => !s.classList.contains(Config.CLASSES.FILLED));
        if (!targetSlot) return;
        state.items[vid] = (state.items[vid] || 0) + 1;
        markDirty();
        if (img && flyToSlot) await flyToSlot(img, targetSlot);
        else updateUI();
      });
    });
    
    // Slot-Klick: Desktop entfernt 1, Mobile ignoriert Tap (Bottom-Sheet macht +/-)
    slots.forEach(slot => {
      slot.addEventListener('click', () => {
        if (Utils.isMobile()) return;
        const vid = slot.dataset.variantId;
        if (!vid) return;
        const cur = state.items[vid] || 0;
        // Context7: Defensive Programming - Validate before modifying
        if (cur <= 1) {
          delete state.items[vid];
        } else {
          state.items[vid] = cur - 1;
        }
        // Context7: Fail Fast - Validate total after modification
        const totalQty = Object.values(state.items).reduce((a, b) => a + b, 0);
        if (totalQty > maxSlots) {
          console.warn('[Bundle Builder] Slot click: Total quantity exceeds maximum, capping');
          state.items = Utils.capToMaximum(state.items, maxSlots);
        }
        markDirty();
        updateUI();
      });
    });
  },
  
  /**
   * Attach form submit intercept (ATC)
   * @param {Object} controller - Controller instance
   * @param {Element} el - Bundle builder element
   * @param {Function} syncCartBundleToState - Sync function
   * @param {Function} renderSummaryImmediate - Render function
   * @param {boolean} openCartAfterAdd - Open cart after add flag
   */
  attachFormIntercept: function(controller, el, syncCartBundleToState, renderSummaryImmediate, openCartAfterAdd) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const SELECTORS = Config.SELECTORS;
    
    const variantIdsInThisProduct = new Set(
      [...el.querySelectorAll('.bb__card')].map(c => String(c.dataset.variantId))
    );
    
    function isFormForThisProduct(form) {
      const idInput = form.querySelector('input[name="id"]');
      const vid = idInput && idInput.value ? String(idInput.value) : '';
      return vid && variantIdsInThisProduct.has(vid);
    }
    
    // Form submit intercept
    document.addEventListener('submit', async (evt) => {
      const form = evt.target?.closest(SELECTORS.PRODUCT_FORM);
      if (!form) return;
      if (!isFormForThisProduct(form)) return;
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation?.();
      
      // Context7: Safety - Double-Submit Prevention
      const submitBtn = form.querySelector(SELECTORS.ATC_BUTTON);
      const wasDisabled = submitBtn?.disabled || form.disabled;
      if (submitBtn) submitBtn.disabled = true;
      if (form) form.disabled = true;
      
      try {
        // Context7: Perceived Performance - Update UI immediately (optimistic)
        if (renderSummaryImmediate) renderSummaryImmediate();
        
        // Context7: Platform-specific loading indicators
        // Desktop: Spinner in form
        // Mobile: Full-screen loading overlay (blurry background + animation)
        const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
        const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
        
        if (!Utils.isMobile()) {
          // Desktop: Show spinner in form
          UIRenderDesktop.toggleSpinner(true, form);
        } else {
          // Mobile: Show full-screen loading overlay (SOT - same as LP and Sticky)
          // Context7: SOT - Mobile loading screen must be consistent across PDP, LP, and Sticky
          if (UIRenderMobile && typeof UIRenderMobile.showMobileLoading === 'function') {
            UIRenderMobile.showMobileLoading();
          }
        }
        
        await syncCartBundleToState();
        
        if (openCartAfterAdd) {
          const cartEl = document.querySelector(SELECTORS.CART_NOTIFICATION) || 
                         document.querySelector(SELECTORS.CART_DRAWER);
          cartEl?.open?.();
        }
      } finally {
        // Context7: Hide loading indicators
        if (!Utils.isMobile()) {
          // Desktop: Hide spinner
          const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
          UIRenderDesktop.toggleSpinner(false, form);
        } else {
          // Mobile: Hide full-screen loading overlay (SOT)
          const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
          if (UIRenderMobile && typeof UIRenderMobile.hideMobileLoading === 'function') {
            UIRenderMobile.hideMobileLoading();
          }
        }
        // Restore button/form state (only if it wasn't disabled before)
        if (submitBtn && !wasDisabled) submitBtn.disabled = false;
        if (form && !wasDisabled) form.disabled = false;
      }
    }, true);
    
    // Button click intercept (alternative to form submit)
    document.addEventListener('click', async (evt) => {
      const btn = evt.target?.closest('product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
      if (!btn) return;
      const form = btn.closest(SELECTORS.PRODUCT_FORM);
      if (!form) return;
      if (!isFormForThisProduct(form)) return;
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation?.();
      
      // Context7: Safety - Double-Submit Prevention
      const wasDisabled = btn.disabled || form.disabled;
      btn.disabled = true;
      if (form) form.disabled = true;
      
      try {
        // Context7: Perceived Performance - Update UI immediately (optimistic)
        if (renderSummaryImmediate) renderSummaryImmediate();
        
        // Context7: Platform-specific loading indicators
        // Desktop: Spinner in form
        // Mobile: Full-screen loading overlay (blurry background + animation)
        const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
        const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
        
        if (!Utils.isMobile()) {
          // Desktop: Show spinner in form
          UIRenderDesktop.toggleSpinner(true, form);
        } else {
          // Mobile: Show full-screen loading overlay (SOT - same as LP and Sticky)
          // Context7: SOT - Mobile loading screen must be consistent across PDP, LP, and Sticky
          if (UIRenderMobile && typeof UIRenderMobile.showMobileLoading === 'function') {
            UIRenderMobile.showMobileLoading();
          }
        }
        
        await syncCartBundleToState();
        
        if (openCartAfterAdd) {
          const cartEl = document.querySelector(SELECTORS.CART_NOTIFICATION) || 
                         document.querySelector(SELECTORS.CART_DRAWER);
          cartEl?.open?.();
        }
      } finally {
        // Context7: Hide loading indicators
        if (!Utils.isMobile()) {
          // Desktop: Hide spinner
          const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
          UIRenderDesktop.toggleSpinner(false, form);
        } else {
          // Mobile: Hide full-screen loading overlay (SOT)
          const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
          if (UIRenderMobile && typeof UIRenderMobile.hideMobileLoading === 'function') {
            UIRenderMobile.hideMobileLoading();
          }
        }
        // Restore button/form state (only if it wasn't disabled before)
        if (!wasDisabled) btn.disabled = false;
        if (form && !wasDisabled) form.disabled = false;
      }
    }, true);
  },
  
  /**
   * Attach sheet event delegation (PDP)
   * @param {Element} sheet - Sheet element
   * @param {Object} callbacks - Callback functions
   * @param {Function} callbacks.onClose - Close callback
   * @param {Function} callbacks.onReset - Reset callback
   * @param {Function} callbacks.onCommit - Commit callback
   * @param {Function} callbacks.onStepperChange - Stepper change callback
   */
  attachSheetDelegation: function(sheet, callbacks) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const SELECTORS = Config.SELECTORS;
    const DATA_ATTRS = Config.DATA_ATTRS;
    
    if (!sheet) return;
    
    // Verhindere mehrfache Anhängung
    if (sheet.dataset[DATA_ATTRS.BB_BUTTONS_ATTACHED.replace('data-', '').replace('-', '')] === 'true') return;
    sheet.setAttribute(DATA_ATTRS.BB_BUTTONS_ATTACHED, 'true');
    
    sheet.addEventListener('click', (e) => {
      // Close Button (unterstützt beide Varianten)
      const closeBtn = e.target.closest(SELECTORS.CLOSE);
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (callbacks.onClose) callbacks.onClose();
        return;
      }
      
      // Reset Button (unterstützt beide Varianten)
      const resetBtn = e.target.closest(SELECTORS.RESET);
      if (resetBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (callbacks.onReset) callbacks.onReset();
        return;
      }
      
      // Commit Button (unterstützt beide Varianten)
      const commitBtn = e.target.closest(SELECTORS.COMMIT);
      if (commitBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (callbacks.onCommit) callbacks.onCommit();
        return;
      }
      
      // Add-Button Handler (öffnet Stepper)
      const addBtn = e.target.closest(SELECTORS.BTN_ADD);
      if (addBtn) {
        const tile = addBtn.closest(SELECTORS.TILE);
        if (tile) {
          const plusBtn = tile.querySelector(SELECTORS.STEPPER_PLUS);
          if (plusBtn) {
            plusBtn.click();
            return;
          }
        }
      }
      
      // Plus/Minus Handler
      const plus = e.target.closest(SELECTORS.STEPPER_PLUS);
      const minus = e.target.closest(SELECTORS.STEPPER_MINUS);
      if (plus || minus) {
        const tile = e.target.closest(SELECTORS.TILE);
        if (!tile) return;
        if (callbacks.onStepperChange) {
          callbacks.onStepperChange({
            variantId: String(tile.dataset.variantId),
            delta: plus ? 1 : -1,
            tile: tile
          });
        }
        return;
      }
    });
  },
  
  /**
   * Attach stepper delegation (PDP)
   * @param {Element} sheet - Sheet element
   * @param {Object} callbacks - Callback functions
   * @param {Function} callbacks.onStepperChange - Stepper change callback
   * @param {boolean} sheetOpen - Sheet open state
   */
  attachStepperDelegation: function(sheet, callbacks, sheetOpen) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const SELECTORS = Config.SELECTORS;
    const DATA_ATTRS = Config.DATA_ATTRS;
    
    if (!sheet) return;
    
    // Verhindere mehrfache Anhängung
    if (sheet.dataset[DATA_ATTRS.BB_STEPPER_ATTACHED.replace('data-', '').replace('-', '')] === 'true') return;
    sheet.setAttribute(DATA_ATTRS.BB_STEPPER_ATTACHED, 'true');
    
    sheet.addEventListener('click', (e) => {
      if (!Utils.isMobile() || !sheetOpen) return;
      
      // Add-Button Handler (öffnet Stepper)
      const addBtn = e.target.closest(SELECTORS.BTN_ADD);
      if (addBtn) {
        const tile = addBtn.closest(SELECTORS.TILE);
        if (tile) {
          const plusBtn = tile.querySelector(SELECTORS.STEPPER_PLUS);
          if (plusBtn) {
            plusBtn.click();
            return;
          }
        }
      }
      
      // Plus/Minus Handler
      const plus = e.target.closest(SELECTORS.STEPPER_PLUS);
      const minus = e.target.closest(SELECTORS.STEPPER_MINUS);
      if (!plus && !minus) return;
      const tile = e.target.closest(SELECTORS.TILE);
      if (!tile) return;
      
      if (callbacks.onStepperChange) {
        callbacks.onStepperChange({
          variantId: String(tile.dataset.variantId),
          delta: plus ? 1 : -1,
          tile: tile
        });
      }
    });
  },
  
  /**
   * Attach global listeners (document-level)
   * @param {Object} controller - Controller instance
   * @param {Function} onEscape - ESC key handler
   */
  attachGlobalListeners: function(controller, onEscape) {
    // ESC key handler
    if (onEscape) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') onEscape(e);
      });
    }
  },
  
  /**
   * Attach focus trap
   * @param {Element} panel - Panel element
   * @param {Function} isOpen - Function to check if open
   */
  attachFocusTrap: function(panel, isOpen) {
    if (!panel) return;
    
    const focusablesSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    
    function trapFocus(e) {
      if (!isOpen()) return;
      if (e.key !== 'Tab') return;
      const nodes = panel.querySelectorAll(focusablesSelector);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }
    
    panel.addEventListener('keydown', trapFocus);
  }
};

